import { render } from "./index.vue?vue&type=template&id=46cce8bb&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "@/style/chapter-list.less?vue&type=style&index=0&id=46cce8bb&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cce8bb"],['__file',"src/views/chapter-list/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46cce8bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46cce8bb', __exports__)) {
    console.log('reload')
    api.reload('46cce8bb', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=46cce8bb&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('46cce8bb', render)
  })

}


export default __exports__